import { render, staticRenderFns } from "./LoginDetails.vue?vue&type=template&id=79e58fb1"
import script from "./LoginDetails.vue?vue&type=script&lang=js"
export * from "./LoginDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports